import { createSvgComponent } from "../../icon/createSvgComponent";
import Pencil from "@core/__generated__/icon/figma/pencil.svg";
export default createSvgComponent(Pencil);